import {Injectable} from '@angular/core';
import {MinizaemApiClientService} from "../../core/services/minizaem-api-client.service";
import {Customer} from "../models/customer";
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends MinizaemApiClientService {
  setToStorage(customer: Customer): void {
    this.cookieService.set("customer", JSON.stringify(customer), this.cookieOptions);
    this.sharedState.customer.set(customer);
  }

  getFromStorage(): Customer | null {
    const storedCustomerJson = this.cookieService.get("customer");
    if (storedCustomerJson) {
      return JSON.parse(storedCustomerJson);
    } else {
      return null;
    }
  }

  getFromApi(): Observable<Customer> {
    return this.http.get<Customer>(this.buildURI(`api/customer`));
  }

  create(customer: Customer): Observable<Customer> {
    return this.http.post<Customer>(this.buildURI(`api/customer/create`), customer);
  }

  update(password: string): Observable<Customer> {
    return this.http.put<Customer>(this.buildURI(`api/customer/update`), {
      password: password,
    });
  }

  checkExistenceBy(propertyName: string, propertyValue: string): Observable<Boolean> {
    return this.http.get(this.buildURI(`api/customer/check-existence-by/${propertyName}/${propertyValue}`)).pipe(
      map((response: any): Boolean => {
        return response.result === true;
      })
    );
  }

  logout(): void {
    this.sharedState.triggerLogoutActions();

    this.cookieService.delete("customer", '/');
    this.cookieService.delete("minizaemApiJwt", '/');
  }

  regeneratePassword(email: string): Observable<any> {
    return this.http.put(this.buildURI(`api/customer/regenerate-password`), {
      email: email
    });
  }
}
